type CardDetailHeroFlags = {
  enabled?: boolean
}

/**
 * A single flag gates the whole overview hero. The hero *replaces* the legacy
 * AccountHeader, and every region (summary, card display, actions menu) renders
 * together, so there is no per-region gate — turning the treatment on shows all
 * of it, off shows the legacy header.
 */
export const shouldShowCardDetailHero = (flags: CardDetailHeroFlags): boolean =>
  flags.enabled === true
